import { trpc } from '@/shared/api/trpc';
import { LATEST_ORG_TICKETS_LIMIT } from '../model/support-constants';

// The current reporter's own tickets (drawer "My" tab). Server forces the
// reporter scope + returns the reduced own-projection (no other reporters'
// data). `enabled` lets the drawer defer the fetch until it is opened.
export const useMyTickets = (enabled = true) =>
  trpc.support.myList.useQuery(
    {
      page: 0,
      pageSize: LATEST_ORG_TICKETS_LIMIT,
      sortBy: 'modifiedOn',
      sortOrder: 'desc',
    },
    { enabled }
  );
